import { useTranslation } from "react-i18next";
import { NewsPaper } from "../../icons";
import { Row, Col } from "react-bootstrap";
import { KURSCard, SBDKCard } from "../";

import "./InformationCard.scss";

const InformationCard = function () {
  const { t } = useTranslation();

  return (
    <div className="information-card">
      <div className="header">
        <div className="col-8 d-flex justify-content-start align-items-center">
          <NewsPaper fill="#85714D" className="icon"/>
          <div className="title color-brown">{t("new_info")}</div>
        </div>
      </div>
      <div className="body">
        <Row>
          <Col xs={12} md={6}>
            <KURSCard />
          </Col>
          <Col xs={12} md={6}>
            <SBDKCard />
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default InformationCard;
